import { Menu, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import { Button } from '@zaplify/ui';
import { ReactNode } from 'react';

export const ViewContainer = styled(({ children, className }: { children?: ReactNode; className: string }) => (
    <div className={className}>{children}</div>
))(({ theme }: { theme: any }) => ({
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '16px',
    '& .table-pagination-container': {
        border: '0.8px solid rgb(228, 230, 235)',
        width: 'calc(100% - 310px) !important',
        bottom: 25,
    },
}));

export const LaunchContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    '& .filter-menu': {
        maxWidth: '328px',
    },
    '& .bulk-action-button-group': {},
}));

export const TableDisplayContainer = styled('div')(({ theme }: { theme: any }) => ({
    flexDirection: 'column',
    height: '100%',
    boxSizing: 'border-box',
    '& .table-sorting-container': {
        marginBottom: 7,
    },
    '& .inner-container': {
        position: 'relative',
        minWidth: 940,
        minHeight: '100%',
        '& .empty_state_container': {
            marginTop: 100,
            '& .button': {
                height: 48,
                borderRadius: '25px',
                fontSize: 14,
                minWidth: 162,
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.colors.white,
                padding: '14px 30px',
                marginTop: 30,
            },
            '& .title': {
                color: theme.palette.colors.black,
                fontWeight: 500,
                fontSize: 24,
            },
            '& .text': {
                marginTop: 18,
                color: theme.palette.colors.subline,
                fontSize: 15,
            },
            '&.no-results': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& .no-result': {
                    fontSize: 15,
                    marginRight: 9,
                },
                '& .emoji': {
                    fontSize: 25,
                },
            },
        },
    },
    '& .logotypes-info': {
        color: theme.palette.colors.lightGrey,
        fontSize: 13,
    },
}));

export const ProspectsSectionContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    '& > div:nth-child(2)': {
        width: '100%',
        '&>.MuiTableContainer-root': {
            display: 'flex',
            '& > table': {
                width: '95%',
                paddingBottom: '100px',
            },
        },
    },
}));

export const TableTopSectionContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'baseline',
    width: '100%',
    flexDirection: 'column',
    boxSizing: 'border-box',
    marginTop: '12px',
    '& .manageProspect': {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        boxSizing: 'border-box',
    },
    '& .unresolvedInfo': {
        width: 750,
        height: 50,
        display: 'flex',
        alignItems: 'center',
        background: '#EFF4FE',
        justifyItems: 'center',
        borderRadius: 14,
        border: '1px solid rgba(95, 142, 250, 0.3)',
        padding: '5px 30px',
        fontSize: 15,
        margin: '15px ',
        fontWeight: 400,
        justifyContent: 'flex-start',
    },
}));

export const MenuContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
}));

export const SelectAllCheckboxContainer = styled('div')(({ theme }) => ({
    background: '#FFFFFF',
    border: `0.8px solid ${theme.palette.colors.greyInformationLight}`,
    boxSizing: 'border-box',
    boxShadow: '0px 2px 6px rgba(112, 144, 176, 0.07)',
    borderRadius: 8,
    display: 'flex',
    width: 'fit-content',
    margin: '12px 0',
    height: '45px',
    '& .borderRight': {
        borderRight: `0.8px solid ${theme.palette.colors.greyInformationLight}`,
    },
    '& .button': {
        color: theme.palette.darkGrey,
        height: '100%',
        padding: '13px 17px',
    },
}));

export const SelectAllSliderContainer = styled('div')(({ theme }) => ({
    background: '#FFFFFF',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #E4E6EB',
    boxShadow: '0px 2px 7px rgba(112, 144, 176, 0.14)',
    borderRadius: 8,
    width: 393,
    zIndex: 100,
    margin: '2px 20px 0 -44px',
    '& > .title': {
        fontWeight: 500,
        fontSize: 15,
        margin: '22px 0 0 22px',
    },
    '& > .slider-container': {
        display: 'flex',
        alignItems: 'center',
        margin: '10px 22px 0 22px',
        '& > p': {
            marginLeft: 20,
            whiteSpace: 'nowrap',
        },
    },
    '& > .divider': {
        borderBottom: '1px solid #E4E6EB',
        marginTop: 16,
    },
    '& > .bottom-container': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 13,
        '& .primary': {
            height: 33,
        },
    },
}));

export const StyledMenu = styled(
    ({ children, className, anchorEl, onClose, onClick, resetOnClick, stylePaperProps }) => (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            className={className}
            PaperProps={{
                style: {
                    transform: 'translateY(103px)',
                    ...stylePaperProps,
                },
            }}
        >
            <ul className="menu-items-container">{children}</ul>
            <div className="apply-container">
                <Typography onClick={resetOnClick} className="reset-button">
                    Reset
                </Typography>
                <Button text="Apply" onClick={onClick} width="103px" height="50px" />
            </div>
        </Menu>
    )
)(({ theme }) => ({
    '& .title': {
        color: theme.palette.colors.greyDark,
        fontSize: 13,
        paddingLeft: 15,
    },
    '& .MuiList-root': {
        height: '100%',
        width: 287,
    },
    '& .menu-items-container': {
        paddingLeft: 0,
        marginLeft: 0,
    },
    '& .apply-container': {
        borderTop: `1px solid ${theme.palette.colors.greyInformationLight}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 64,
        padding: '0 20px 0 17px',
        '& .reset-button': {
            border: 'none',
            backgroundColor: 'transparent',
            color: theme.palette.colors.greyDark,
            textDecoration: 'underline',
            fontSize: 15,
            fontWeight: 400,
            cursor: 'pointer',
        },
        '& .apply-button': {
            height: 40,
            width: 103,
        },
    },
    '& .MuiFormControlLabel-root': {
        marginRight: 0,
    },
    '& .MuiCheckbox-root': {
        marginLeft: 5,
        color: theme.palette.colors.greyPaleIcon,
        '&.Mui-checked': {
            color: theme.palette.colors.bluePale,
        },
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
}));

export const StatusFilterContainer = styled('div')(({ color, theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    height: '52px',
    marginRight: '38px',
    boxShadow: '0px 2px 6px rgba(112, 144, 176, 0.07)',
    borderRadius: '8px',
    '& .status': {
        display: 'flex',
        flexDirection: 'row',
        height: '50px',
        alignItems: 'center',
        background: 'white',
        border: `1px ${theme.palette.colors.greyInformationLight}`,
        borderStyle: 'solid solid solid none',
        cursor: 'pointer',
        padding: '0 17px',
        '&:hover': {
            boxShadow: '0px 8px 24px rgba(112, 144, 176, 0.15)',
        },
        '&.filterInactive': {
            background: theme.palette.colors.greySelect,
        },
        '&.filterActive': {
            background: theme.palette.colors.white,
        },
        '&.completed': {
            '& .details-container': {
                display: 'flex',
                alignItems: 'center',
                '& .circle': {
                    display: 'flex',
                    width: 32,
                    height: 32,
                    background: theme.palette.colors.greySelect,
                    borderRadius: 50,
                    marginLeft: 14,
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& .number': {
                        color: theme.palette.colors.subline,
                        fontSize: 14,
                        margin: 0,
                    },
                },
                '& .arrow': {
                    color: theme.palette.colors.lightGrey,
                },
            },
        },
        '& .icon': {
            cursor: 'pointer',
            paddingRight: '12px',
            alignSelf: 'center',
            '& .info-icon': {
                fontSize: '18px',
            },
        },
        '& .icon-number-wrapper': {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            '& .color-icon': {
                borderRadius: '50%',
                width: '11px',
                height: '11px',
                marginRight: '10px',
                backgroundColor: color,
            },
        },
    },
    '& .status-0-border': {
        borderLeft: `1px solid ${theme.palette.graphics.stroke}`,
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
    },
    '& .status-4-border': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
    },
}));
